import { defaultApiState } from '@/store/types/general.types';
import { JournalState } from '.';

export const journalState: JournalState = {
  apiState: {
    getJournals: defaultApiState,
  },
  journals: undefined,
};
